import { render, staticRenderFns } from "./Gretting.vue?vue&type=template&id=c59e5958&"
import script from "./Gretting.vue?vue&type=script&lang=js&"
export * from "./Gretting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports